import { ruleRunner } from 'validations/ruleRunner';
import { required, isEmail, minimun, maximum, hasNoValue } from 'validations/rules';

const Validations = (minimumCommissionValue = '0.01', maxCommissionValue = '100') => {
  return [
    ruleRunner('email', 'e-mail do parceiro', required, isEmail),
    ruleRunner(
      'comission_value',
      'porcentagem',
      hasNoValue('action', 'remove', minimun(minimumCommissionValue)),
      hasNoValue('action', 'remove', maximum(maxCommissionValue))
    )
  ];
};

export default Validations;
